import { useIntl } from 'react-intl';

import useTimeFormat from 'hooks/useTimeFormat';

import cpDashboardTableConfig from './CPDashboardTableConfig';

import { CPDashboardTableProps } from './types';

import * as S from './styles';

const CPDashboardTable: React.FC<CPDashboardTableProps> = ({
  loading,
  filterType,
  patientsInfo,
}) => {
  const intl = useIntl();

  const { formatToDDMMYYYYString } = useTimeFormat();

  const handleRediretToPatientProfile = (cognitoId: string) => {
    window.open(`/new-provider/enduser/${cognitoId}`);
  };

  const { columnsFilterType } = cpDashboardTableConfig({
    intl,
    formatToDDMMYYYYString,
    handleRediretToPatientProfile,
  });

  const currentTableColumns = columnsFilterType[filterType];

  const nameColumnWidth = currentTableColumns.find(
    column => column.dataKey === 'fullName',
  )?.width;

  const hasActionButton = !!currentTableColumns.find(
    column => column.dataKey === 'actions',
  );

  // Name column and Action Column have fixed width so do not count to the quantity;
  const columnsQuantity = hasActionButton
    ? currentTableColumns.length - 2
    : currentTableColumns.length - 1;

  return (
    <S.Container>
      <S.StyledTable
        fixedHeader
        loading={loading}
        loadingStyle="LinesSmall"
        data={patientsInfo}
        nameColumnWidth={nameColumnWidth}
        hasActionColumn={hasActionButton}
        columnsQuantity={columnsQuantity}
        columns={currentTableColumns}
      />
    </S.Container>
  );
};

export default CPDashboardTable;
